<template>
  <div class="filter-list" :class="{'sl': useSmallList}">
    <search-filter-equipments />
    <search-filter-group />
    <search-sorter/>
  </div>
</template>

<script>
import SearchFilterGroup from "../picker/search-filter-group";
import SearchFilterEquipments from "../picker/search-filter-equipments";
import SearchSorter from "./search-sorter";
export default {
  name: "search-filters",
  components: {SearchSorter, SearchFilterEquipments, SearchFilterGroup},
  computed: {
    useSmallList () {
      return this.$store.getters["search/roomGroups"].length <= 1;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/search/parts/search-filters.vue